import './App.css';
import Calculator from './Calcutator';

function App() {

  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;
